// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"235":"f9bd19fb","329":"16ca8066","377":"60d1be31","493":"d65b7810"}[chunkId] + ".chunk.js";
};